<template>
  <v-card class="secondary mb-10">
    <div v-if="question">
      <v-card-text class="text-left">
        <div v-html="question.question" class="break-word mb-2 title"></div>
        <div v-if="!alreadyAnswered" class="mb-n6">
          <v-btn
            text
            @click="hasAnswered(answer)"
            v-for="answer in orderedAnswers"
            :key="answer"
            style="width: 100%"
          >
            {{ answer }}
          </v-btn>
        </div>
        <div v-else class="mb-n6">
          <div
            v-for="item in orderedResults"
            :key="item[0]"
            style="position: relative"
            class="my-5"
          >
            <div
              style="height: 22px;
								    position: absolute;
								    top: 0px;
								    left: 0px;
								    background: rgba(255, 255, 255, 0.2);
								    border-radius: 3px;"
              :style="{
                width: pourcentageOfTotal(item[1]) + '%',
                background:
                  alreadyAnswered == item[0]
                    ? 'rgba(254, 7, 72, 0.2)'
                    : 'rgba(255, 255, 255, 0.2)'
              }"
            ></div>
            <span class="ml-4"
              ><b>{{ item[0] }}</b>
              <div
                style="position: relative; top: 0; display: inline"
                :style="{
                  left:
                    pourcentageOfTotal(item[1]) - 16 > 3
                      ? pourcentageOfTotal(item[1]) - 16 + '%'
                      : '3%'
                }"
              >
                {{ item[1] }} votes
                <span v-if="alreadyAnswered == item[0]" class="grey--text">
                  - my vote
                </span>
              </div>
            </span>
          </div>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-row justify="space-between">
          <v-col class="pt-0 text-left">
            <v-btn text @click="showExpansion = !showExpansion">
              <v-icon class="mr-2 ml-n2">{{
                showExpansion ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
              {{ commentsLength > 0 ? commentsLength : "" }} comments
            </v-btn>
          </v-col>
          <v-col class="pt-0 mr-2 mt-2 text-right">
            <span class="caption"
              >{{ question.audit_created_at | parseDate }}
            </span>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-expand-transition>
        <div v-show="showExpansion">
          <v-divider></v-divider>

          <v-card-text v-if="questionLoaded">
            <ListComments
              @commentPosted="commentPosted"
              :news_question_id="question.id"
            />
          </v-card-text>
        </div>
      </v-expand-transition>
    </div>
  </v-card>
</template>
<script>
import axios from "axios";
import SendRequestMixin from "../mixins/SendRequestMixin";

export default {
  name: "ItemQuestion",
  mixins: [SendRequestMixin],
  data() {
    return {
      commentsLength: 0,
      showExpansion: false,
      question: [],
      currentAnswer: {}
    };
  },
  components: {
    ListComments: () => import("./ListComments.vue")
  },
  methods: {
    pourcentageOfTotal(result) {
      let total = 0;

      for (let option in this.question.users_results) {
        total += this.question.users_results[option];
      }
      return (result / total) * 100;
    },
    async hasAnswered(answer) {
      this.currentAnswer = {
        id: this.question.id,
        currentAnswer: answer
      };
      this.question.users_results[answer] += 1;

      localStorage.setItem("answer", JSON.stringify(this.currentAnswer));

      // (optional) Wait until recaptcha has been loaded.
      let token = "";
      if (window.location.href.includes("hans-zimmer.com")) {
        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login".
        token = await this.$recaptcha("login");
      }

      axios.post(`${this.$BASE_URL}/answer_question`, {
        headers: {},
        data: {
          id: this.question.id,
          answer: answer,
          token: token
        }
      });
    },
    commentPosted() {
      this.commentsLength += 1;
    },
    videoToken(videoUrl) {
      if (videoUrl.includes("watch"))
        return this._.split(videoUrl, "watch?v=")[1];
      if (videoUrl.includes("embed"))
        return this._.split(videoUrl, "embed/")[1];
      if (videoUrl.includes("youtube.com/v/"))
        return this._.split(videoUrl, "youtube.com/v/")[1];
    },
    getData() {
      let _vm = this;

      this.sendRequest({
        endpoint: "/get/newsquestions?order_by=id&relations=comments",
        store_as: "question"
      }).then(() => {
        let localAsnwer = JSON.parse(localStorage.getItem("answer"));
        if (localAsnwer && localAsnwer["id"] == _vm.question.id) {
          _vm.currentAnswer = localAsnwer;
        }
      });
    },
    sortByFirstLetter(array) {
      if (!array) return [];
      debugger; // eslint-disable-line no-debugger
      return array;
    }
  },
  watch: {
    comments(value) {
      if (value == null) this.commentsLength = 0;
      this.commentsLength = value.length;
    }
  },
  computed: {
    questionLoaded() {
      return this.question.id != undefined;
    },
    comments() {
      if (!this.question || !this.question.comments) return null;
      return this.question.comments;
    },
    alreadyAnswered() {
      if (this.currentAnswer.id && this.currentAnswer.id == this.question.id)
        return this.currentAnswer.currentAnswer;
      return null;
    },
    orderedAnswers() {
      let copy = this.question.answers;

      if (!copy) return [];

      copy.sort(function(a, b) {
        let nameA = a.toLowerCase(),
          nameB = b.toLowerCase();
        if (nameA < nameB)
          //sort string ascending
          return -1;
        if (nameA > nameB) return 1;
        return 0; //default return value (no sorting)
      });
      return this.question.answers;
    },
    orderedResults() {
      let sortable = [];
      for (let result in this.question.users_results) {
        sortable.push([result, this.question.users_results[result]]);
      }
      sortable.sort(function(a, b) {
        let nameA = a[0].toLowerCase(),
          nameB = b[0].toLowerCase();
        if (nameA < nameB)
          //sort string ascending
          return -1;
        if (nameA > nameB) return 1;
        return 0; //default return value (no sorting)
      });

      return sortable;
    }
    // comments() {
    // 	if (!this.$props.news || !this.$props.news.comments)
    // 		return null
    // 	return this.$props.news.comments
    // },
    // author() {
    // 	if (!this.$props.news.author || !this.$props.news.author.name)
    // 		return null
    // 	return this.$props.news.author.name
    // }
  },
  mounted() {
    if (this.comments == null) this.commentsLength = 0;
    else this.commentsLength = this.comments.length;

    this.getData();
  }
};
</script>
